import { FormHelperText } from "@mui/material";
import TextField from "@mui/material/TextField";
import classNames from "classnames";
import { forwardRef } from "react";
import { ControlProps } from "react-select";
import { SelectOption } from "./types";

const inputComponent = forwardRef<HTMLDivElement, any>((props, ref) => {
  return (
    <div ref={ref} {...props} style={{ display: "flex", height: "100%" }} />
  );
});

export function Control({
  children,
  innerProps,
  innerRef,
  selectProps: {
    classes,
    customNoResult,
    hasError,
    options,
    searchInputValue,
    textFieldProps,
  },
}: ControlProps<SelectOption>) {
  return (
    <>
      <TextField
        fullWidth
        InputProps={{
          inputComponent,
          inputProps: {
            children,
            className: classNames(
              classes.input,
              hasError && classes.inputError,
            ),
            ref: innerRef,
            ...(innerProps as any),
          },
        }}
        variant="standard"
        {...textFieldProps}
      />
      {customNoResult &&
        options.length === 0 &&
        searchInputValue.length >= customNoResult.minChars && (
          <FormHelperText>{customNoResult.message}</FormHelperText>
        )}
    </>
  );
}
